<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-20" :bodyStyle="{ paddingTop: '20px' }">
      <template #title>
        <h6><a @click="goToMainPage" class="mr-5"><a-icon type="arrow-left" /></a>Photo Form</h6>
        <p class="mt-0 mb-0">
          <!-- Booking should be apply up to 10 days before you will use or promote event -->
          <!-- In case of booking a car after working hours, the admin will arrange
          the car within working hours of the following day (9:00 - 16:00). -->
        </p>
        <p class="mt-0 mb-0">
          For urgent matter, please contact 02-700-5000 Ext.1015
        </p>
      </template>

      <a-form :layout="'horizontal'" :form="form">
        <a-form-item label="Email" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
          <a-input v-model="formData.contact_mail" placeholder="enter email ..." v-decorator="[
            'contact_mail',
            { initialValue: formData.contact_mail, rules: [{ required: true, message: 'Please input your data.' }] },
          ]" />
        </a-form-item>

        <a-form-item label="Contact" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
          <a-input v-model="formData.contact_tel" placeholder="enter contact ..." v-decorator="[
            'formData.contact_tel',
            { initialValue: formData.contact_tel, rules: [{ required: true, message: 'Please input your data.' }] },
          ]" />
        </a-form-item>

        <a-form-item label="Name of Event" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input v-model="formData.name_of_event" placeholder="" v-decorator="[
            'formData.name_of_event',
            { initialValue: formData.name_of_event, rules: [{ required: true, message: 'Please input your data.' }] },
          ]" />
        </a-form-item>

        <!-- Event date -->
        <a-form-item label="Date of Event" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
          <a-date-picker class="mr-10" v-model="dateTimeEvent.event_date_start" :disabled-date="disabledDate" v-decorator="[
            'formData.event_date_start',
            { initialValue: formData.event_date_start, rules: [{ required: true, message: 'Please input your data.' }] },
          ]" />
          
        </a-form-item>
        <!-- Event date -->

        <!-- Event time -->
        <a-form-item label="Time of Event" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
          
          <span class="mr-10">
            <a-time-picker format="HH:mm" v-model="dateTimeEvent.event_time_start" :minuteStep="5"
              :default-open-value="moment('08:00', 'HH:mm')" v-decorator="[
                'formData.event_time_start',
                { initialValue: formData.event_time_start, rules: [{ required: true, message: 'Please input your data.' }] },
              ]" />
          </span>
          -
          <span class="ml-10">
            <a-time-picker format="HH:mm" v-model="dateTimeEvent.event_time_end" :minuteStep="5"
              :default-open-value="moment('08:00', 'HH:mm')" v-decorator="[
                'formData.event_time_end',
                { initialValue: formData.event_time_end, rules: [{ required: true, message: 'Please input your data.' }] },
              ]" />
          </span>
        </a-form-item>
        <!-- Event time -->

        <!-- Location of Event -->
        <a-form-item label="Location of Event" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-select show-search placeholder="select location of event ..." option-filter-prop="children"
            v-model="formData.location" v-decorator="[
              'formData.location',
              { initialValue: formData.location, rules: [{ required: true, message: 'Please input your data.' }] },
            ]">
            <a-select-option v-for="(item, index) in optionLocation" :key="'location' + index" :value="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-if="formData.location === 'others'" label="Others" :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }" extra="Please Specify Location">
          <a-input v-model="formData.location_other" placeholder="" v-decorator="[
            'formData.location_other',
            { initialValue: formData.location_other, rules: [{ required: true, message: 'Please input your data.' }] },
          ]" />
        </a-form-item>

        
        <a-form-item label="Room Details" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input v-model="formData.room_detail" placeholder="" />
        </a-form-item>

        <!-- Location of Event -->

        <!-- Type of Event -->
        <a-form-item label="Type of Event" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-select show-search placeholder="select type of event ..." option-filter-prop="children"
            v-model="formData.type_event" v-decorator="[
              'formData.type_event',
              { initialValue: formData.type_event, rules: [{ required: true, message: 'Please input your data.' }] },
            ]">
            <a-select-option v-for="(item, index) in optionEventType" :key="'location' + index" :value="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-if="formData.type_event === 'other'" label="Others" :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }" extra="Please Specify other Type of Event">
          <a-input v-model="formData.type_event_other" placeholder="" v-decorator="[
            'formData.type_event_other',
            { initialValue: formData.type_event_other, rules: [{ required: true, message: 'Please input your data.' }] },
          ]" />
        </a-form-item>

        <!-- Type of Event -->
        <a-form-item label="Details of Event" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
          <a-textarea placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" v-model="formData.detail_of_event" />
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 20, offset: 4 }">
          <p v-if="!isformData" :style="{ color: 'grey' }">Please fill out all required fields.</p>
          <a-button type="primary" :disabled="!isformData" @click="visible = true" class="mr-10">
            Submit
          </a-button>
          <a-button type="danger" @click="clearForm"> Cancel </a-button>
        </a-form-item>

      </a-form>
    </a-card>
    <a-modal title="Confirm" :visible="visible" :confirm-loading="confirmLoading" @ok="submitForm"
      @cancel="visible = false">
      <p>Are you sure to Submit ?</p>
    </a-modal>
  </div>
</template>

<script>
const form = {
  contact_mail: '',
  contact_tel: '',
  name_of_event: '',
  location: '',
  location_other: '',
  type_event: '',
  type_event_other: '',
  room_detail: '',
  detail_of_event: '',
}
const formDateTimeEvent = {
  event_date_start: '',
  event_time_start: '',
  event_date_end: '',
  event_time_end: ''
}
import authService from '../../../../services/authService';

export default {
  data() {
    return {
      formData: { ...form },
      dateTimeEvent: { ...formDateTimeEvent },
      optionLocation: [
        { label: 'Building 1', value: 'building_1' },
        { label: 'Building 2', value: 'building_2' },
        { label: 'Building 3', value: 'building_3' },
        { label: 'Aditayathorn Building', value: 'aditayathorn_building' },
        { label: 'Others', value: 'others' },
      ],
      optionEventType: [
        { label: 'Activity', value: 'activity' },
        { label: 'Field Trips', value: 'field_trips' },
        { label: 'Seminar', value: 'seminar' },
        { label: 'Teaching', value: 'teaching' },
        { label: 'Visiting', value: 'visiting' },
        { label: 'Others', value: 'other' },
      ],
      loadBtnSubmit: false,
      errorSubmit: "",
      visible: false,
      confirmLoading: false,
      curDaytBooking: 3,
      limitDayBooking: 30
    };
  },
  computed: {
    isformData() {
      if (
        this.formData.contact_mail &&
        this.formData.contact_tel &&
        this.formData.name_of_event &&
        (this.formData.location != 'others' ? this.formData.location :
          this.formData.location_other
        ) &&
        (this.formData.type_event != 'other' ? this.formData.type_event :
          this.formData.type_event_other
        ) &&
        this.dateTimeEvent.event_date_start &&
        this.dateTimeEvent.event_time_start &&
        this.dateTimeEvent.event_date_end &&
        this.dateTimeEvent.event_time_end
      ) {
        return true;
      } else {
        return false;
      }
    },
    isTimeBooking() {
      if (
        this.formData.timeStart !== "" &&
        this.formData.timeEnd !== ""
      ) {
        let start = `${this.moment(this.formData.dayStart).format(
          "DD/MM/YYYY"
        )} ${this.moment(this.formData.timeStart, "HH:mm:ss").format(
          "HH:mm:ss"
        )}`;
        let end = `${this.moment(this.formData.dayEnd).format(
          "DD/MM/YYYY"
        )} ${this.moment(this.formData.timeEnd, "HH:mm:ss").format(
          "HH:mm:ss"
        )}`;
        let ms = this.moment(start, "DD/MM/YYYY HH:mm:ss").diff(
          this.moment(end, "DD/MM/YYYY HH:mm:ss")
        );
        if (ms > 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
  mounted() {
    // Priority 1: Keycloak email
    if (this.$keycloak && this.$keycloak.authenticated && this.$keycloak.tokenParsed) {
      this.formData.contact_mail = this.$keycloak.tokenParsed.email;
    } else {
      // Priority 2: MSAL email
      const msalAccount = authService.getAccount();
      if (msalAccount) {
        this.formData.contact_mail = msalAccount.username || '';
      }
    }
    this.formData.contact_tel = this.$store.state.role.RulesUser.tel;
    console.log(this.$store.state.role.RulesUser.roles)
  },
  watch: {
    "dateTimeEvent.event_date_start"(newValue, oldValue) {
      this.dateTimeEvent.event_date_end = newValue
    }
  },
  beforeCreate() {
    // Creates the form and adds to it component's "form" property.
    this.form = this.$form.createForm(this, { name: 'normal_login' });
  },
  methods: {

    goToMainPage() {
      this.$router
        .push({
          path: "/booking/pr/photo",
        })
        ;
    },
    disabledDate(endEventDate) {
      let curDate = new Date();
      let limitDate = new Date();
      // add day limitDayBooking

      curDate.setDate(curDate.getDate() + this.curDaytBooking);
      limitDate.setDate(limitDate.getDate()+ this.curDaytBooking + this.limitDayBooking)

      return this.moment(endEventDate).format("YYYY-MM-DD") < this.moment(curDate).format("YYYY-MM-DD")
        || this.moment(endEventDate).format("YYYY-MM-DD") > this.moment(limitDate).format("YYYY-MM-DD");
    },
    clearForm() {
      this.formData = { ...form };
      // Priority 1: Keycloak email
      if (this.$keycloak && this.$keycloak.authenticated && this.$keycloak.tokenParsed) {
        this.formData.contact_mail = this.$keycloak.tokenParsed.email;
      } else {
        // Priority 2: MSAL email
        const msalAccount = authService.getAccount();
        if (msalAccount) {
          this.formData.contact_mail = msalAccount.username || '';
        }
      }
      this.formData.contact_tel = this.$store.state.role.RulesUser.tel;
      this.$router
        .push({
          path: "/booking/pr/photo",
        })
        ;
    },
    async submitForm() {
      this.loadBtnSubmit = true;
      this.errorSubmit = null;
      const sendData = new FormData();
      let jsonData = this.formData
      //set datetime event
      jsonData.event_datetime_start = this.moment(this.dateTimeEvent.event_date_start).format("YYYY-MM-DD") + "T" +
        this.moment(this.dateTimeEvent.event_time_start, "HH:mm:ss").format("HH:mm:ss") +
        "+07:00"
      jsonData.event_datetime_end = this.moment(this.dateTimeEvent.event_date_end).format("YYYY-MM-DD") + "T" +
        this.moment(this.dateTimeEvent.event_time_end, "HH:mm:ss").format("HH:mm:ss") +
        "+07:00"

      jsonData.location = jsonData.location != 'others' ? jsonData.location : jsonData.location_other
      //del other field for create data format 
      delete jsonData['location_other'];

      //set none data 
      console.log(jsonData)
      try {
        const response = await this.$http.post("/booking/photo/add/", jsonData);
        if (response.status === 201) {
          this.clearForm();
          this.visible = false;
        } else {
          const error = new Error('Request Failed');
          error.response = response;
          throw error;
        }
      } catch (error) {
        this.loadBtnSubmit = false;
        this.errorSubmit = error;
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /vehicle/booking/`,
        });
      }
    },
  },
};
</script>